import styles from "./RightPanelWidgetLoader.module.scss";
import {ReactComponent as Loader} from "./loader.svg";

export default () => {
    return  <div className={styles.base}>
        <Loader/>
    </div>
}
